<mat-accordion
    *ngIf="type !== filterTypes.OPTIONAL"
    multi
    displayMode="flat"
    togglePosition="before">
    <mat-expansion-panel opened>
        <mat-expansion-panel-header>
            <mat-panel-title> {{ 'Default Team' }} </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-chip-listbox
            st-click-stop-propagation
            class="st-filter-manage-team-members-options"
            [(ngModel)]="selectedTeam">
            <mat-chip-option
                *ngFor="let team of globalTablesService?.GroupsArray"
                class="st-filter-manage-team-members-options-item"
                [value]="team.ID"
                (selectionChange)="filterTeamMembers()">
                {{ team.Description }}
            </mat-chip-option>
        </mat-chip-listbox>
    </mat-expansion-panel>

    <mat-divider class="st-filter-divider" />

    <mat-expansion-panel opened>
        <mat-expansion-panel-header>
            <mat-panel-title> {{ 'Role' }} </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-chip-listbox
            st-click-stop-propagation
            class="st-filter-manage-team-members-options"
            [(ngModel)]="selectedRole">
            <mat-chip-option
                *ngFor="let role of roles"
                class="st-filter-manage-team-members-options-item"
                [value]="role.ID"
                (selectionChange)="filterTeamMembers()">
                {{ role.Description }}
            </mat-chip-option>
        </mat-chip-listbox>
    </mat-expansion-panel>

    <mat-divider class="st-filter-divider" />

    <mat-expansion-panel opened>
        <mat-expansion-panel-header>
            <mat-panel-title> {{ 'Status' }} </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-chip-listbox
            st-click-stop-propagation
            class="st-filter-manage-team-members-options"
            [(ngModel)]="selectedStatus">
            <mat-chip-option
                *ngFor="let status of filterMemberStatus"
                class="st-filter-manage-team-members-options-item"
                [value]="status.StatusNumber"
                (selectionChange)="filterTeamMembers()">
                {{ status.StatusName }}
            </mat-chip-option>
        </mat-chip-listbox>
    </mat-expansion-panel>
</mat-accordion>
